import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DocumentUpload = ({
  upload: {
    id,
    filename,
  },
  onDelete,
  isSelected,
  onSelect,
}) => {
  return (
    <div className="mb-3">
      <button
        className={`btn btn-${isSelected ? 'primary' : 'outline-primary'} d-flex align-items-center justify-content-between w-100`}
        onClick={() => onSelect(id)}
      >
        <span className="text-truncate me-2">{filename}</span>
        <div className="d-flex align-items-center">
          <button
            className="btn btn-link btn-sm p-0 ms-2"
            onClick={(e) => {
              e.stopPropagation();
              onDelete(id);
            }}
          >
            <FontAwesomeIcon icon={['far', 'trash-alt']} />
          </button>
        </div>
      </button>
    </div>
  );
};

const StudentUploadsList = ({ studentUploads, onDelete }) => {
  const [selectedUploadId, setSelectedUploadId] = useState(studentUploads[0]?.id);
  const selectedUpload = studentUploads.find(upload => upload.id === selectedUploadId);

  return (
    <div>
      {selectedUpload && (
        <div className="student-document-viewer">
          {selectedUpload.content_type?.includes('pdf') ? (
            <iframe
              src={selectedUpload.url}
              type="application/pdf"
              width="100%"
              height="100%"
              style={{ border: 'none' }}
              title={selectedUpload.filename}
            />
          ) : (
            <img
              src={selectedUpload.url}
              alt={selectedUpload.filename}
              style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            />
          )}
        </div>
      )}
      <div className="mt-4">
        {studentUploads.map((upload) => (
          <DocumentUpload
            key={upload.id}
            upload={upload}
            onDelete={onDelete}
            isSelected={upload.id === selectedUploadId}
            onSelect={setSelectedUploadId}
          />
        ))}
      </div>
    </div>
  );
};

export default StudentUploadsList;
